import { render, staticRenderFns } from "./SuccessSendForm.vue?vue&type=template&id=61f5ea31&"
import script from "./SuccessSendForm.vue?vue&type=script&lang=js&"
export * from "./SuccessSendForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports